import React, {useCallback, useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {useNavigate} from "react-router-dom";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FaEdit, FaPlus} from "react-icons/fa";
import {getCroppedImg} from "../../functions/getCroppedImg";
import Cropper from "react-easy-crop";

const AdminGallery = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [modalImageShown, setModalImageShown] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);
    const [coverImages, setCoverImages] = useState([]);
    const [loading, setLoading] = useState(false)

    const [modalData, setModalData] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!hasRoleAccess(sectionId, user.role))
            navigate("/")
        getImages();
    }, []);

    // API functions - get/delete
    // ------------------------------------------------------------------------------
    async function getImages() {
        setLoading(true)
        const configurationCover = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/upload?coverImg=true`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const configurationGallery = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/upload`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configurationCover)
            .then((result) => {
                setCoverImages(result.data.content);

                axios(configurationGallery)
                    .then((result) => {
                        setGalleryImages(result.data.content);
                    })
                    .catch((error) => {
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                    });
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    };

    async function handleDeleteImage(imageId) {
        setLoading(true)
        try {
            const configuration = {
                method: "delete",
                url: `${process.env.REACT_APP_API_BASE_URL}/upload/${imageId}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setCoverImages(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
        } catch (error) {
            opsToast("Chyba pri mazání obrázka!", "error");
        }
        setLoading(false)
    }

    // MODAL
    // ------------------------------------------------------------------------------
    function handleOpenModalImage(img, coverImg = false) {
        if (img) {
            setModalImageShown(true);
            setModalData({img: img, coverImg: coverImg})
        } else {
            setModalImageShown(true);
            setModalData(null);
        }
    }

    function handleModalsClose() {
        setModalImageShown(false)
        setModalData(null)
    }

    const ModalImage = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)
        const [image, setImage] = useState(null);
        const [preview, setPreview] = useState(modalData?.img.path ? `${process.env.REACT_APP_API_BASE_URL}/${modalData.img.path}` : "");
        const [crop, setCrop] = useState({x: 0, y: 0});
        const [zoom, setZoom] = useState(1);
        const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


        // API funkcie - nahratie obrazka galeria/titulna
        // ------------------------------------------------------------------------------
        async function postGalleryImage() {
            if (!image) {
                opsToast("Obrázok nebol vybratý!", "error");
                return;
            }

            setProcessed(true);
            try {
                // Orezanie obrázka podľa výberu
                const croppedImageBlob = await getCroppedImg(preview, croppedAreaPixels);
                // Pred odoslaním na server, pridaj parameter `aspectRatio`
                const formData = new FormData();
                formData.append("image", croppedImageBlob, "cropped-image.jpg");
                formData.append("aspectRatio", (4 / 3));
                formData.append("order", modalData ? modalData.img.order : 0)
                formData.append("coverImg", false);

                // Ak existuje starý obrázok, pridáme jeho cestu na odstránenie
                if (modalData) {
                    formData.append("oldImageId", modalData.img._id);
                }

                const configuration = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/upload/upload-and-delete`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                    data: formData,
                }

                axios(configuration)
                    .then((result) => {
                        opsToast(result?.data?.message, "success");
                        setGalleryImages(result.data.content)
                        handleModalsClose();
                    })
                    .catch((error) => {
                        console.log(error)
                        opsToast(error.message, "error", "colored", true, "top-center");
                    });
            } catch (error) {
                opsToast("Chyba pri nahrávaní obrázka!", "error");
            } finally {
                setProcessed(false);
            }
        }

        async function postCoverImage() {
            if (!image) {
                opsToast("Obrázok nebol vybratý!", "error");
                return;
            }

            setProcessed(true);
            try {
                const croppedImageBlob = await getCroppedImg(preview, croppedAreaPixels);

                const formData = new FormData();
                formData.append("image", croppedImageBlob, "cropped-image.jpg");
                formData.append("aspectRatio", (16 / 9));
                formData.append("order", modalData ? modalData.img.order : coverImages?.length)
                formData.append("coverImg", true);

                // Ak existuje starý obrázok, pridáme jeho cestu na odstránenie
                if (modalData) {
                    formData.append("oldImageId", modalData.img._id);
                }

                const configuration = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/upload${modalData !== null ? '/upload-and-delete' : ''}`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                    data: formData,
                }

                axios(configuration)
                    .then((result) => {
                        opsToast(result?.data?.message, "success");
                        setCoverImages(result.data.content)
                        handleModalsClose();
                    })
                    .catch((error) => {
                        console.log(error)
                        opsToast(error.message, "error", "colored", true, "top-center");
                    });
            } catch (error) {
                opsToast("Chyba pri nahrávaní obrázka!", "error");
            } finally {
                setProcessed(false);
            }
        }

        // funkcie na spracovanie obrazka - crop,upload, API upload
        const onCropComplete = useCallback((_, croppedAreaPixels) => {
            setCroppedAreaPixels(croppedAreaPixels);
        }, []);

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                setImage(file);
                setPreview(URL.createObjectURL(file));
            }
        };

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {!processed ?
                        <div className="custom-modal-content justify-content-between">

                            {/*FOTOGRAFIE*/}
                            <div className="fa-flex-col gap-1 my-2">
                                <OpsText type="normal" alignment="left" color="color-1"
                                         content="Vyberte obrázok"/>
                                <div className="desktop-row-phone-col fa-w-100 align-items-center">
                                    <OpsInput
                                        required
                                        id="coverImage"
                                        customType="imgUpload"
                                        componentClassName="fa-w-100"
                                        size="bg"
                                        value={preview}
                                        onChange={handleFileChange}
                                    />
                                </div>
                                {preview && (
                                    <div className="adm-preset-img-3 mt-2 position-relative">
                                        <Cropper
                                            image={preview}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={4 / 3}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={onCropComplete}
                                        />
                                    </div>
                                )}
                            </div>

                            {image !== null &&
                                <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                    <OpsBtn
                                        text="Zahodiť"
                                        variant="secondary"
                                        size="md mt-2"
                                        action={handleModalsClose}
                                    />
                                    <OpsBtn
                                        text="Uložiť"
                                        variant="primary"
                                        size="md mt-2"
                                        action={modalData === null ? postCoverImage : modalData.coverImg ? postCoverImage : postGalleryImage}
                                    />
                                </div>
                            }

                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalImage show={modalImageShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="GALÉRIA"/>

            {!loading && <div className="fa-flex-col">
                {/* TITULNE FOTOGRAFIE */}
                <div className="adm-container fa-flex-col align-items-center">
                    <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                        <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                                 content="Titulné fotografie"/>
                    </div>
                    {/*NAHLAD A EDITACIA TITULNYCH FOTOGRAFII*/}
                    <div
                        className="desktop-row-phone-col fa-w-90 align-items-center justify-content-start mt-4 gap-0">
                        {coverImages.length < 7 && <OpsBtn
                            id="coverImg-create"
                            tooltipText="Pridať titulnú fotografiu"
                            icon={<FaPlus color="var(--color-p-300)"
                                          className="ops-icon-sm m-1 mx-3"/>}
                            variant="icon mx-1 desktop-h-100-phone-w-100 m-2"
                            backgroundColor="bg-3 border border-1"
                            padding={false}
                            action={() => {
                                handleOpenModalImage()
                            }}
                        />}
                        {coverImages
                            ?.sort((a, b) => a.order - b.order)
                            .map((img, index) => (
                                <div className="position-relative desktop-15-phone-100" key={index}>
                                    <img className="adm-preset-img"
                                         src={`${process.env.REACT_APP_API_BASE_URL}/${img.path}`} key={index} alt=""/>
                                    <div className="adm-preset-img-btn">
                                        <OpsBtn
                                            icon={<FaEdit color="color-1" className="ops-icon-sm m-1"/>}
                                            variant="icon m-1 p-1"
                                            padding={false}
                                            action={() => handleOpenModalImage(img, true)}
                                        />
                                        {coverImages.length > 1 && <OpsBtn
                                            icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                                            variant="icon m-1 p-1"
                                            backgroundColor="bg-red"
                                            padding={false}
                                            action={() => handleDeleteImage(img._id)}
                                        />}
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>

                {/* GALERIA */}
                <div className="adm-container fa-flex-col">
                    <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                        <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                                 content="Galéria fotografií"/>
                    </div>
                    {/*NAHLAD A EDITACIA GALERIE*/}
                    <div className="fa-flex-wrap fa-w-100 align-items-center justify-content-center mt-4 gap-0">
                        {galleryImages
                            ?.sort((a, b) => a.order - b.order)
                            .map((img, index) => (
                                <div className="position-relative desktop-15-phone-50" key={index}>
                                    <img className="adm-preset-img"
                                         src={`${process.env.REACT_APP_API_BASE_URL}/${img.path}`} key={index} alt=""/>
                                    <OpsBtn
                                        icon={<FaEdit color="color-1" className="ops-icon-sm m-1"/>}
                                        variant="icon adm-preset-img-btn m-1 p-1"
                                        padding={false}
                                        action={() => handleOpenModalImage(img)}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default AdminGallery;